import {Component, Input, OnInit} from '@angular/core';
import {BreadCrumb} from '../../models/breadcrumb';
import {BehaviorSubject} from 'rxjs';
import {MatCard, MatCardContent} from '@angular/material/card';
import {RouterLink} from '@angular/router';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.css'],
    imports: [
        MatCard,
        MatCardContent,
        RouterLink
    ],
    standalone: true
})
export class BreadcrumbsComponent implements OnInit {

    crumbs: BreadCrumb[];
    private breadcrumbs = new BehaviorSubject<BreadCrumb[]>([]);

    constructor() {
    }

    @Input()
    set data(value: BreadCrumb[]) {
        this.breadcrumbs.next(value);
    }

    ngOnInit() {
        this.breadcrumbs.subscribe(x => {
            this.crumbs = x;
        });
    }
}
